'use client'

import React from 'react'
import Image from 'next/image'

interface RecipesEmptyStateProps {
  message: string
  actionLabel?: string
  onAction?: () => void
  action?: React.ReactNode
}

export function RecipesEmptyState({
  message,
  actionLabel,
  onAction,
  action,
}: RecipesEmptyStateProps) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 py-12">
      <Image
        src="/assets/icons/sad-salad-bowl.svg"
        alt=""
        width={125}
        height={125}
        unoptimized
        className="h-[125px] w-[125px] object-contain"
      />
      <p className="max-w-[286px] text-center text-sm leading-6 text-[#6B6B6B]">
        {message}
      </p>
      {action ??
        (actionLabel && onAction ? (
          <button
            type="button"
            onClick={onAction}
            className="flex h-[43px] items-center justify-center rounded-full bg-[#85C349] px-8 text-base text-white hover:bg-[#75B339]"
          >
            {actionLabel}
          </button>
        ) : null)}
    </div>
  )
}
